import styled from "styled-components";
import {
  IconButton,
  StyledBuyButton,
  GradientText,
  IconBackground,
} from "./styled";
import PlusIcon from "../assets/icons/plus.svg";
import MinusIcon from "../assets/icons/minus.svg";
import cardsIcon from "../assets/icons/cards.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useBottomSheet } from "../context/BottomSheetContext";
// import BuyProductConfirmationModalContent from "./buyConfirmationModalContent";
// import { useWalletContext } from "../context/WalletContext";
import theme from "../styles/theme";
import { useToaster } from "../hooks/useToaster";
import { useUserContext } from "../context/UserContext";
import CountdownTimer from "./shared/countDown";
import { createCheckOutTransaction } from "../service/main/api";
import { checkTokenAllowance,approveToken,buyCartWithQuote } from "../service/web3/checkout";
import { MaxUint256 } from "ethers";
import {useLoading} from "../context/LoadingContext";
import { useTokenContext } from "../context/TokenContext";
import MarketbuyConfirmModalContent from "./marketBuyConfirmModalContent";
import {formatEthers} from "../utils";
import { useAccount ,useSwitchChain} from "wagmi";
import { BSC_CHAIN_ID } from "../service/web3/wagmi";

const ProductBuySection = ({ product }) => {
  const [amount, setAmount] = useState(1);
  const { openSheet, closeSheet } = useBottomSheet();
  const { user } = useUserContext();
  const connectedAddress = user?.walletAddress || "";
  const { showToaster } = useToaster();
  const [countDown, setCountDown] = useState(0);
  const [productPrice, setProductPrice] = useState(0);
  const [approved, setApproved] = useState(false);
  const { setIsLoading } = useLoading();
  const { novaPrice } = useTokenContext();
    const { chainId: accountChainId } = useAccount();
    const { switchChainAsync, isPending: isSwitching } = useSwitchChain();
  
  useEffect(() => {
    const checkAllowance = async () => {
      if (!connectedAddress) return;
            if (accountChainId !== BSC_CHAIN_ID) {
              try {          await switchChainAsync({ chainId: BSC_CHAIN_ID });
              } catch (error) {
                console.error("Failed to switch chain:", error);
                return;
              }
            };
      const response = await checkTokenAllowance({
        owner: connectedAddress,
        spender: process.env.REACT_APP_CHECKOUT_CONTRACT_ADDRESS, // replace with actual spender address
        tokenAddress: process.env.REACT_APP_PAYMENT_TOKEN_ADDRESS, // replace with actual token address
        requiredAmount: MaxUint256.toString(), // you can set this to the maximum uint256 value or calculate based on product price and amount
      });
      if (response.success) {
        setApproved(response.data.isEnough);
      } else {
        console.error("Failed to check token allowance:", response.error);
      }
    };
    checkAllowance();
  }, [connectedAddress, amount, product]);
  const navigate = useNavigate();
  const handleApprove = async () => {
    setIsLoading(true);
    const response = await approveToken({
      tokenAddress: process.env.REACT_APP_PAYMENT_TOKEN_ADDRESS, // replace with actual token address
      spender: process.env.REACT_APP_CHECKOUT_CONTRACT_ADDRESS, // replace with actual spender address
      amount: MaxUint256.toString(), // you can set this to the maximum uint256 value or calculate based on product price and amount
    });
    if (response.success) {
      showToaster({ type: "success", message: "Approval successful!" });
      setApproved(true);
    } else {
      console.error("Failed to approve token:", response.error);
      showToaster({ type: "error", message: "Approval failed. Please try again." });
    }
    setIsLoading(false);
  };
  const handleBuy = async () => {
    if (product.isLimited && product.soldAmount + amount > product.limitCount) {
      alert("You can not buy more than the limit");
      return;
    }
    setIsLoading(true);
    const res  = await createCheckOutTransaction({
         basket:[
           {
             productId: product.productId,
             quantity: amount,
             productName: product.item.name,
             productImage: product.item.imageUri,
           }
         ]
     });
       if (!res.success) {
         console.error("Failed to create checkout transaction:", res.error);
         showToaster({ type: "error", message: res.message || "Failed to create checkout transaction. Please try again." });
         setIsLoading(false);
         return;
       }
       console.log("Checkout transaction created successfully:", res.data);
    setIsLoading(false);
     openSheet({
       content: (
         <MarketbuyConfirmModalContent
           navigate={navigate}
           onClose={handleOnClose}
           onConfirm={() => handleConfirm({
            items:[
              {
                productId: product.productId,
                quantity: amount,
              }
            ],
            quote: res.data.quote,
            signature: res.data.signature,
           })}
           totalCost={formatEthers(res.data.quote.tokenAmount)}
           products={[{...product,count:amount}]}
         />
       )
     });
  };
  const handleConfirm = async (data) => {
    setIsLoading(true);
     const buyRes =  await buyCartWithQuote(data);
     if (buyRes.success) {
       console.log("Purchase successful:", buyRes.data);
        showToaster({ type: "success", message: "Purchase successful!,Keep check in order history" });
        handleOnClose("success");
     } else {
       console.error("Failed to complete purchase:", buyRes.error);
       showToaster({ type: "error", message: "Purchase failed. Please try again." });
       handleOnClose();
     }
      setIsLoading(false);
  };
  const handleOnClose = (type) => {
    closeSheet();
    if (type === "success") {
      navigate("/orders");
    }
  };
  
  const handleAmountChange = (type) => {
    try {
    if (type === "plus") {
       if (product.limitPerOrder) {
         if (amount >= product.limitPerOrder) {
           showToaster({
             type: "error",
             message: `You can not buy more than ${product.limitPerOrder} packs`,
           });
           return;
         }
       }
      setAmount(amount + 1);
    } else {
      if (amount > 1) {
        setAmount(amount - 1);
      }
    }
    } catch (error) {
        console.error("Error changing amount", error);
    }
  };
  useEffect(() => {
    if (product.discount) {
      if (product.discount.discountType === "percentage") {
        setProductPrice(
          product.price - product.price * product.discount.discountValue,
        );
      } else if (product.discount.type === "fixed") {
        setProductPrice(product.price - product.discount.discountValue);
      }
      return;
    }
    setProductPrice(product.price);
  }, [product]);
  useEffect(() => {
    if (product.needToWaitForNewOrder) {
      const lastBoughtTime = user?.certainIntervalProducts
        ? user?.certainIntervalProducts[product._id] || 0
        : 0;
      const currentTime = Math.floor(Date.now());
      const timeDiff = currentTime - lastBoughtTime;
      const timeLeft = product.needWaitingTime - timeDiff;
      if (timeLeft > 0) {
        setCountDown(timeLeft / 1000);
      }
    }
  }, [product, user]);
  if (product?.item.items) {
    return (
      <Container>
        <IconButtonContainer>
          <IconButton onClick={() => handleAmountChange("minus")}>
            <IconBackground $backgroundColor={"#FFA402"} $height="100%" />
            <IconBackground
              $backgroundColor={theme.yellow.background}
              $height="92%"
            />
            <IconBackground $backgroundColor={theme.yellow.gradient} />
            <StyledIcon src={MinusIcon} alt="Minus Icon" />
          </IconButton>
          <MiddleContainer>
            <StyledCardsIcon src={cardsIcon} alt="Cards Icon" />
            <Details>
              <AmountText>{amount} Pack</AmountText>
              {/* <ItemDetailText>{amount * product?.item.totalCardsInPack} Cards</ItemDetailText> */}
            </Details>
          </MiddleContainer>
          <IconButton onClick={() => handleAmountChange("plus")}>
            <IconBackground $backgroundColor={"#FFA402"} $height="100%" />
            <IconBackground
              $backgroundColor={theme.yellow.background}
              $height="92%"
            />
            <IconBackground $backgroundColor={theme.yellow.gradient} />
            <StyledIcon src={PlusIcon} alt="Minus Icon" />
          </IconButton>
        </IconButtonContainer>
        {countDown > 0 ? (
          <StyledBuyButton style={{ marginTop: "2vh" }}>
            <Shine />
            <Shine $top="93%" $width="80%" />
            <strong style={{ fontSize: "16px" }}>Next buy:</strong>
            <span style={{ marginLeft: "4px", fontSize: "18px" }}>
              {countDown > 60 * 60 * 24 ? (
                <>
                  {`${Math.floor(countDown / (60 * 60 * 24))}d `}
                  <CountdownTimer
                    initialSeconds={Math.floor(
                      countDown -
                        Math.floor(countDown / (60 * 60 * 24)) * (60 * 60 * 24),
                    )}
                  />
                </>
              ) : (
                <CountdownTimer initialSeconds={countDown} />
              )}
            </span>
          </StyledBuyButton>
        ) : (
          <StyledBuyButton
            onClick={approved ? handleBuy : handleApprove}
            style={{ marginTop: "2vh" }}
          >
            <Shine />
            <Shine $top="93%" $width="80%" />
              {approved ?
              <>
                <TokenIcon src={product?.currency.imageUri} alt="Token Icon" />
                {product.discount ? (
                  <>
                    <del
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        marginLeft: "4px",
                        color: "#fcd013",
                      }}
                    >
                      {product.price}
                    </del>
                    <PriceInToken>
                       {Math.round(product.priceInUsd / novaPrice * amount)} {product.currency.symbol}
                    </PriceInToken>
                  </>
                ) : (
                  <PriceInToken>
                     {Math.round(product.priceInUsd / novaPrice * amount)} {product.currency.symbol}
                  </PriceInToken>
                )}
              </>
              : <PriceInToken>Approve</PriceInToken>}

            {/* <PriceInDollar>${(productPrice * amount * 3.5).toFixed(3)}</PriceInDollar> */}
          </StyledBuyButton>
        )}
      </Container>
    );
  }
  return (
    <Container>
      <IconButtonContainer>
        <IconButton onClick={() => handleAmountChange("minus")}>
          <IconBackground $backgroundColor={"#FFA402"} $height="100%" />
          <IconBackground
            $backgroundColor={theme.yellow.background}
            $height="92%"
          />
          <IconBackground $backgroundColor={theme.yellow.gradient} />
          <StyledIcon src={MinusIcon} alt="Minus Icon" />
        </IconButton>
        <MiddleContainer>
          <StyledCardsIcon src={cardsIcon} alt="Cards Icon" />
          <Details>
            <AmountText>{amount} Pack</AmountText>
            <ItemDetailText>
              {amount * product?.item.totalCardsInPack} Cards
            </ItemDetailText>
          </Details>
        </MiddleContainer>
        <IconButton onClick={() => handleAmountChange("plus")}>
          <IconBackground $backgroundColor={"#FFA402"} $height="100%" />
          <IconBackground
            $backgroundColor={theme.yellow.background}
            $height="92%"
          />
          <IconBackground $backgroundColor={theme.yellow.gradient} />
          <StyledIcon src={PlusIcon} alt="Minus Icon" />
        </IconButton>
      </IconButtonContainer>
      <StyledBuyButton
        onClick={approved ? handleBuy : handleApprove}
        style={{ marginTop: "2vh" }}
      >
        <Shine />
        <Shine $top="93%" $width="80%" />
          {approved ?           <>
            <TokenIcon src={product?.currency.imageUri} alt="Token Icon" />
            {product.discount ? (
              <>
                <del
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    marginLeft: "4px",
                    color: "#fcd013",
                  }}
                >
                  {product.price}
                </del>
                <PriceInToken>
                   {Math.round(product.priceInUsd / novaPrice * amount)} {product.currency.symbol}
                </PriceInToken>
              </>
            ) : (
              <PriceInToken>
                 {Math.round(product.priceInUsd / novaPrice * amount)} {product.currency.symbol}
              </PriceInToken>
            )}
          </> :  <PriceInToken>Approve</PriceInToken>}


        {/* <PriceInDollar>${(product?.price * amount * 3.5).toFixed(3)}</PriceInDollar> */}
      </StyledBuyButton>
    </Container>
  );
};

export const Container = styled.div`
  width: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const StyledIcon = styled.img`
  width: calc(4 * var(--vw));
  z-index: 2;
`;

export const IconButtonContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 10px;
`;
export const MiddleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
`;
export const StyledCardsIcon = styled.img`
  width: 36px;
  margin-top: -12px;
`;
export const AmountText = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.light};
`;
export const ItemDetailText = styled.span`
  font-size: 22px;
  font-weight: 800;
  color: ${(props) => props.theme.colors.text.secondary};
`;
export const Details = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const TokenIcon = styled.img`
  width: 30px;
`;
export const PriceInToken = styled(GradientText)`
  font-size: 20px;
  font-weight: 800;
  margin-left: 6px;
`;
export const PriceInDollar = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.text.secondary};
  margin-left: 12px;
`;

const Shine = styled.div`
  position: absolute;
  width: ${(props) => props.$width || "90%"};
  top: ${(props) => props.$top || "-10px"};
  height: 20px;
  border-radius: 100%;
  background: radial-gradient(closest-side, #ffffff70, #ffffff50, #ffffff00);
`;
export default ProductBuySection;
